import { getCookie, setCookie } from 'cookies-next';
import { getOrCreateVisitorId } from '@/shared/utils/visitor-id';
import { TIME_CONSTANTS_IN_SECONDS } from '@ecom/helper-utils';

const STORE_TOKEN_COOKIE = 'wt_store_token';

export const getOrCreateStoreToken = async (): Promise<string> => {
  const existingStoreToken = await getCookie(STORE_TOKEN_COOKIE);

  if (existingStoreToken) {
    return existingStoreToken;
  }

  const visitorId = await getOrCreateVisitorId();

  setCookie(STORE_TOKEN_COOKIE, visitorId, {
    maxAge: TIME_CONSTANTS_IN_SECONDS.ONE_YEAR,
    path: '/',
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production',
  });

  return visitorId;
};
